<template>
  <a-modal title="编辑体检单项" :visible="visible" :width="900"
           :confirmLoading="confirmLoading" :destroyOnClose="true" :maskClosable='false'
           @ok="handleSubmit" @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="体检科室" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-select placeholder="请选择体检科室" v-decorator="['baMedicalDepartmentId', {rules: [{required: true, message: '请选择体检科室'}]}]"
                    show-search :filter-option="handleDeptFilterOption" :options="examDeptList"
          />
        </a-form-item>

        <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-input v-decorator="['projectName']" readOnly />
        </a-form-item>

        <a-form-item label="项目价格" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-input-number style='width: 100%'  placeholder="请输入项目价格" v-decorator="['projectPrice', {rules: [{required: true, message: '请输入项目价格'}]}]" :min="0"/>
        </a-form-item>

        <a-form-item label="项目编码" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-input placeholder="请输入项目编码" v-decorator="['projectNum', {rules: [{required: true, message: '请输入项目编码'}]}]" />
        </a-form-item>

        <a-form-item label="性别限定" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-select placeholder="请输入药品类型" v-decorator="['gender', {rules: [{required: true, message: '请选择性别限定'}]}]">
            <a-select-option key='1' value="1">适用男性</a-select-option>
            <a-select-option key='2' value="2">适应女性</a-select-option>
            <a-select-option key='3' value="3">不限</a-select-option>
          </a-select>
        </a-form-item>

        <!--隐藏域-->
        <a-form-item v-show="false">
          <a-input v-decorator="['id']" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import {qryExamDeptList, editExamProject} from '@/api/modular/interhospital/subItems/subItems';

  /**
   * @Description: 体检单项编辑
   */
  export default {
    data() {
      return {
        form: this.$form.createForm(this),

        labelCol: {xs: {span: 24}, sm: {span: 5}},
        wrapperCol: {xs: {span: 24}, sm: {span: 15}},

        confirmLoading: false,
        visible: false,
        examDeptList: [], // 体检科室
      }
    },

    methods: {
      // 初始化方法
      edit(record) {
        this.visible = true;
        this.handleGetExamDeptList();

        setTimeout(() => {
          this.form.setFieldsValue({
            id: record.id,
            baMedicalDepartmentId: record.baMedicalDepartmentId,
            projectName: record.projectName,
            projectPrice: record.projectPrice,
            projectNum: record.projectNum,
            gender: record.gender,
          })
        }, 100)
      },

      // 获取体检科室信息
      handleGetExamDeptList() {
        qryExamDeptList().then(res => {
          if (res.code == 200) {
            this.examDeptList = [];

            res.data.map(item => this.examDeptList.push({value: item.deptId + "", label: item.deptName}));
          } else {
            this.$message.error(res.message)
          }
        });
      },
      // 过滤筛选体检科室
      handleDeptFilterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      // 修改提交
      handleSubmit() {
        const {form: {validateFields}} = this;
        this.confirmLoading = true;

        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key]);
              }
            }

            editExamProject(values).then((res) => {
              if (res.code == 200) {
                this.$message.success('编辑成功');
                this.confirmLoading = false;
                this.$emit('ok', values);
                this.handleCancel();

              } else {
                this.$message.error('编辑失败')
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          } else {
            this.confirmLoading = false;
          }
        })
      },

      // 关闭modal框
      handleCancel() {
        this.form.resetFields();
        this.visible = false;
      },
    }
  }
</script>
